import React, { useState } from 'react';
import { Icon } from '@iconify/react';
const initialPosts = [{
  id: 1,
  stato: 'Bozza',
  titoloOpera: 'Titolo opera',
  titolo: 'Titolo post',
  soggettoProponente: 'Siae Test 4 - modifica',
  bando: 'Bando 1 - Nuove Opere',
  candidatura: '202601055306',
  data: '20/02/2026'
}, {
  id: 2,
  stato: 'Bozza',
  titoloOpera: 'La luce della sera',
  titolo: "Nuovo titolo dell'opera",
  soggettoProponente: 'Siae Test 4 - modifica',
  bando: 'Bando 1 - Nuove Opere',
  candidatura: '202601055305',
  data: '19/02/2026'
}, {
  id: 3,
  stato: 'Bozza',
  titoloOpera: 'Il cortometraggio lungo',
  titolo: 'Dal foglio Excel al primo ciak: il progetto è ufficialme...',
  soggettoProponente: 'Siae Test 4 - modifica',
  bando: 'Bando 1 - Nuove Opere',
  candidatura: '202601055306',
  data: '19/02/2026'
}, {
  id: 4,
  stato: 'Bozza',
  titoloOpera: 'La luce del mattino',
  titolo: "Primo sopralluogo: lo spazio c'è, ora va riempito di s...",
  soggettoProponente: 'Siae Test 4 - modifica',
  bando: 'Bando 1 - Nuove Opere',
  candidatura: '202601055305',
  data: '19/02/2026'
}, {
  id: 5,
  stato: 'Bozza',
  titoloOpera: 'La luce del mattino',
  titolo: 'La chiamata che cambia tutto',
  soggettoProponente: 'Siae Test 4 - modifica',
  bando: 'Bando 1 - Nuove Opere',
  candidatura: '202601055305',
  data: '19/02/2026'
}];
const CARD_SHADOW = 'none';
const CARD_BORDER = '1px solid #E4E4E4';
const StatoBadge = ({
  stato
}: {
  stato: string;
}) => {
  const colorMap: Record<string, {
    bg: string;
    color: string;
  }> = {
    Bozza: {
      bg: '#ff9800',
      color: '#fff'
    },
    Pubblicato: {
      bg: '#4caf50',
      color: '#fff'
    },
    Archiviato: {
      bg: '#9e9e9e',
      color: '#fff'
    }
  };
  const style = colorMap[stato] || colorMap['Bozza'];
  return <span style={{
    backgroundColor: style.bg,
    color: style.color,
    borderRadius: '4px',
    padding: '4px 12px',
    fontSize: '12px',
    fontWeight: 500,
    fontFamily: 'Roboto, sans-serif',
    display: 'inline-block',
    whiteSpace: 'nowrap'
  }} data-id="element-1027">
      {stato}
    </span>;
};
const filterInputStyle: React.CSSProperties = {
  width: '100%',
  height: '28px',
  padding: '0 6px',
  border: '1px solid #E4E4E4',
  borderRadius: '8px',
  fontSize: '11px',
  fontFamily: 'Roboto, sans-serif',
  color: '#444',
  outline: 'none',
  backgroundColor: 'white'
};
const filterSelectStyle: React.CSSProperties = {
  width: '100%',
  height: '28px',
  padding: '0 4px',
  border: '1px solid #E4E4E4',
  borderRadius: '8px',
  fontSize: '11px',
  fontFamily: 'Roboto, sans-serif',
  color: '#444',
  outline: 'none',
  backgroundColor: 'white'
};
export function GestioneDiario() {
  const [searchQuery, setSearchQuery] = useState('');
  const [statoFilter, setStatoFilter] = useState('Tutti');
  const [filters, setFilters] = useState({
    stato: 'TUTTI',
    titoloOpera: '',
    titolo: '',
    soggettoProponente: '',
    bando: '',
    candidatura: '',
    data: ''
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const filteredData = initialPosts.filter(item => {
    const matchesSearch = item.titoloOpera.toLowerCase().includes(searchQuery.toLowerCase()) || item.titolo.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesHeaderFilter = statoFilter === 'Tutti' || item.stato === statoFilter;
    const matchesFilters = (filters.stato === 'TUTTI' || item.stato === filters.stato) && item.titoloOpera.toLowerCase().includes(filters.titoloOpera.toLowerCase()) && item.titolo.toLowerCase().includes(filters.titolo.toLowerCase()) && item.soggettoProponente.toLowerCase().includes(filters.soggettoProponente.toLowerCase()) && item.bando.toLowerCase().includes(filters.bando.toLowerCase()) && item.candidatura.toLowerCase().includes(filters.candidatura.toLowerCase()) && item.data.includes(filters.data);
    return matchesSearch && matchesHeaderFilter && matchesFilters;
  });
  const totalItems = filteredData.length;
  const startItem = (currentPage - 1) * rowsPerPage + 1;
  const endItem = Math.min(currentPage * rowsPerPage, totalItems);
  const currentData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
  const handleFilterChange = (key: string, value: string) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
    setCurrentPage(1);
  };
  return <div style={{
    fontFamily: 'Roboto, sans-serif'
  }} data-id="element-1028">
      {/* Page Header */}
      <div className="bg-white flex items-center justify-between" style={{
      padding: '24px 32px',
      border: CARD_BORDER,
      boxShadow: CARD_SHADOW,
      borderRadius: '8px'
    }} data-id="element-1029">
        <h1 style={{
        fontSize: '24px',
        fontWeight: 400,
        color: '#293B54',
        fontFamily: 'Roboto, sans-serif',
        margin: 0
      }} data-id="element-1030">
          Gestione Diario Per Chi Crea
        </h1>

        {/* Filtra per stato */}
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
      }} data-id="element-1031">
          <label style={{
          fontSize: '12px',
          color: '#666',
          fontFamily: 'Roboto, sans-serif'
        }} data-id="element-1032">
            Filtra per stato
          </label>
          <select value={statoFilter} onChange={e => {
          setStatoFilter(e.target.value);
          setCurrentPage(1);
        }} style={{
          border: '1px solid #ccc',
          padding: '6px 12px',
          fontSize: '14px',
          fontFamily: 'Roboto, sans-serif',
          minWidth: '120px',
          color: '#293B54',
          outline: 'none',
          backgroundColor: 'white',
          cursor: 'pointer',
          borderRadius: '2px'
        }} data-id="element-1033">
            <option value="Tutti" data-id="element-1034">Tutti</option>
            <option value="Bozza" data-id="element-1035">Bozza</option>
            <option value="Pubblicato" data-id="element-1036">Pubblicato</option>
            <option value="Archiviato" data-id="element-1037">Archiviato</option>
          </select>
        </div>
      </div>

      {/* Table Container */}
      <div className="bg-white" style={{
      marginTop: '24px',
      padding: '24px',
      border: CARD_BORDER,
      boxShadow: CARD_SHADOW
    }} data-id="element-1038">
        {/* Search Row */}
        <div className="flex items-center gap-3 mb-4" data-id="element-1039">
          <div className="relative" style={{
          width: '300px'
        }} data-id="element-1040">
            <Icon icon="tabler:search" fontSize={16} style={{
            position: 'absolute',
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#AAAAAA'
          }} data-id="element-1041" />
            <input type="text" placeholder="Cerca nei post..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} style={{
            width: '100%',
            height: '36px',
            paddingLeft: '32px',
            paddingRight: '10px',
            border: '1px solid #E4E4E4',
            borderRadius: '9999px 0 0 9999px',
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif',
            outline: 'none',
            color: '#293B54'
          }} onFocus={e => e.target.style.borderColor = '#293B54'} onBlur={e => e.target.style.borderColor = '#E4E4E4'} data-id="element-1042" />
          </div>
          <button style={{
          width: '36px',
          height: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #E4E4E4',
          background: 'white',
          cursor: 'pointer',
          color: '#666',
          borderRadius: '0 9999px 9999px 0'
        }} data-id="element-1043">
            <Icon icon="tabler:adjustments-horizontal" fontSize={16} data-id="element-1044" />
          </button>
        </div>

        {/* Table */}
        <div style={{
        overflowX: 'auto'
      }} data-id="element-1045">
          <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          minWidth: '1200px'
        }} data-id="element-1046">
            <thead data-id="element-1047">
              {/* Header Row */}
              <tr data-id="element-1048">
                {[{
                label: 'Stato',
                width: '100px'
              }, {
                label: 'Titolo Progetto',
                width: '150px'
              }, {
                label: 'Titolo',
                width: '220px'
              }, {
                label: 'Soggetto Proponente',
                width: '170px'
              }, {
                label: 'Bando',
                width: '160px'
              }, {
                label: 'Candidatura',
                width: '130px'
              }, {
                label: 'Data',
                width: '100px'
              }, {
                label: 'Azioni',
                width: '80px'
              }].map(col => <th key={col.label} style={{
                textAlign: 'left',
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 600,
                color: '#666',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                borderBottom: '2px solid #E4E4E4',
                fontFamily: 'Roboto, sans-serif',
                width: col.width,
                whiteSpace: 'nowrap'
              }} data-id="element-1049">
                    {col.label}
                  </th>)}
              </tr>

              {/* Filter Row */}
              <tr style={{
              backgroundColor: '#fafafa'
            }} data-id="element-1050">
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1051">
                  <select value={filters.stato} onChange={e => handleFilterChange('stato', e.target.value)} style={filterSelectStyle} data-id="element-1052">
                    <option value="TUTTI" data-id="element-1053">TUTTI</option>
                    <option value="Bozza" data-id="element-1054">Bozza</option>
                    <option value="Pubblicato" data-id="element-1055">Pubblicato</option>
                    <option value="Archiviato" data-id="element-1056">Archiviato</option>
                  </select>
                </td>
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1057">
                  <input type="text" value={filters.titoloOpera} onChange={e => handleFilterChange('titoloOpera', e.target.value)} style={filterInputStyle} data-id="element-1058" />
                </td>
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1059">
                  <input type="text" value={filters.titolo} onChange={e => handleFilterChange('titolo', e.target.value)} style={filterInputStyle} data-id="element-1060" />
                </td>
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1061">
                  <input type="text" value={filters.soggettoProponente} onChange={e => handleFilterChange('soggettoProponente', e.target.value)} style={filterInputStyle} data-id="element-1062" />
                </td>
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1063">
                  <input type="text" value={filters.bando} onChange={e => handleFilterChange('bando', e.target.value)} style={filterInputStyle} data-id="element-1064" />
                </td>
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1065">
                  <input type="text" value={filters.candidatura} onChange={e => handleFilterChange('candidatura', e.target.value)} style={filterInputStyle} data-id="element-1066" />
                </td>
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1067">
                  <input type="date" value={filters.data} onChange={e => handleFilterChange('data', e.target.value)} style={{
                  ...filterInputStyle,
                  width: '100%'
                }} data-id="element-1068" />
                </td>
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1069"></td>
              </tr>
            </thead>

            <tbody data-id="element-1070">
              {currentData.map(row => <tr key={row.id} style={{
              borderBottom: '1px solid #f0f0f0'
            }} onMouseEnter={e => (e.currentTarget as HTMLTableRowElement).style.backgroundColor = '#fafafa'} onMouseLeave={e => (e.currentTarget as HTMLTableRowElement).style.backgroundColor = 'transparent'} data-id="element-1071">
                  <td style={{
                padding: '12px 16px'
              }} data-id="element-1072">
                    <StatoBadge stato={row.stato} data-id="element-1073" />
                  </td>
                  <td style={{
                padding: '12px 16px',
                fontSize: '14px',
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-1074">
                    {row.titoloOpera}
                  </td>
                  <td style={{
                padding: '12px 16px',
                fontSize: '14px',
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                maxWidth: '220px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }} data-id="element-1075">
                    {row.titolo}
                  </td>
                  <td style={{
                padding: '12px 16px',
                fontSize: '14px',
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-1076">
                    {row.soggettoProponente}
                  </td>
                  <td style={{
                padding: '12px 16px',
                fontSize: '14px',
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-1077">
                    {row.bando}
                  </td>
                  <td style={{
                padding: '12px 16px',
                fontSize: '14px',
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-1078">
                    {row.candidatura}
                  </td>
                  <td style={{
                padding: '12px 16px',
                fontSize: '14px',
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-1079">
                    {row.data}
                  </td>
                  <td style={{
                padding: '12px 16px'
              }} data-id="element-1080">
                    <div style={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'center'
                }} data-id="element-1081">
                      <button style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#666',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center'
                  }} onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.color = '#293B54'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.color = '#666'} title="Visualizza" data-id="element-1082">
                        <Icon icon="tabler:eye" fontSize={18} data-id="element-1083" />
                      </button>
                      <button style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#666',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center'
                  }} onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.color = '#4caf50'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.color = '#666'} title="Approva" data-id="element-1084">
                        <Icon icon="tabler:check" fontSize={18} data-id="element-1085" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '16px',
        paddingTop: '12px',
        borderTop: '1px solid #E4E4E4',
        marginTop: '4px'
      }} data-id="element-1086">
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '13px',
          color: '#666',
          fontFamily: 'Roboto, sans-serif'
        }} data-id="element-1087">
            <span data-id="element-1088">Righe per pagina:</span>
            <select value={rowsPerPage} onChange={e => {
            setRowsPerPage(Number(e.target.value));
            setCurrentPage(1);
          }} style={{
            border: 'none',
            background: 'transparent',
            fontSize: '13px',
            color: '#666',
            fontFamily: 'Roboto, sans-serif',
            cursor: 'pointer',
            outline: 'none',
            fontWeight: 500
          }} data-id="element-1089">
              <option value={10} data-id="element-1090">10</option>
              <option value={25} data-id="element-1091">25</option>
              <option value={50} data-id="element-1092">50</option>
            </select>
          </div>
          <span style={{
          fontSize: '13px',
          color: '#666',
          fontFamily: 'Roboto, sans-serif'
        }} data-id="element-1093">
            {totalItems === 0 ? '0-0' : `${startItem}-${endItem}`} di{' '}
            {totalItems}
          </span>
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '2px'
        }} data-id="element-1094">
            <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} style={{
            background: 'none',
            border: 'none',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
            color: '#666',
            opacity: currentPage === 1 ? 0.4 : 1,
            padding: '4px',
            display: 'flex',
            alignItems: 'center'
          }} data-id="element-1095">
              <Icon icon="tabler:chevron-left" fontSize={20} data-id="element-1096" />
            </button>
            <button onClick={() => setCurrentPage(p => p + 1)} disabled={endItem >= totalItems} style={{
            background: 'none',
            border: 'none',
            cursor: endItem >= totalItems ? 'not-allowed' : 'pointer',
            color: '#666',
            opacity: endItem >= totalItems ? 0.4 : 1,
            padding: '4px',
            display: 'flex',
            alignItems: 'center'
          }} data-id="element-1097">
              <Icon icon="tabler:chevron-right" fontSize={20} data-id="element-1098" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}